<h1>Cookies</h1>

<p>bzconfregistration.azurewebsites.net maakt gebruik van cookies en webstatistieken. Hieronder leest u waarom. En u
  ziet welke cookies bzconfregistration.azurewebsites.net en de bz conferencing app precies plaatst en met welk doel.
</p>

<h2>Welk soort cookies gebruikt bzconfregistration.azurewebsites.net?</h2>
<p>De website bzconfregistration.azurewebsites.net gebruikt cookies voor webstatistieken.</p>

<h2>Trackingcookies</h2>
<p>Trackingcookies zijn cookies die bezoekers tijdens het surfen over andere websites kunnen volgen. Deze website
  gebruikt geen trackingcookies. De website biedt daarom geen ondersteuning voor de DoNotTrack-instelling van browsers.
  bzconfregistration.azurewebsites.net houdt zich aan de in Nederland geldende wetgeving.</p>

<h2>Cookies voor webstatistieken</h2>
<p>bzconfregistration.azurewebsites.net gebruikt cookies voor webstatistieken. Dat doen we om te begrijpen hoe bezoekers
  de website gebruiken. Deze informatie helpt de site te verbeteren. Bijvoorbeeld door informatie aan te vullen of door
  het gebruikersgemak te verbeteren. Dit soort cookies heeft geen impact op uw privacy. Ze vallen daarom onder de
  uitzondering van de cookiebepaling in de Telecommunicatiewet. Als gevolg daarvan vragen
  bzconfregistration.azurewebsites.net en bz conferencing app geen toestemming voor het plaatsen van deze cookies.</p>

<h2>Webstatistieken</h2>
<p>Voor het bijhouden van webstatistieken gebruikt bzconfregistration.azurewebsites.net het open source webanalysepakket
  Matomo en analyseert deze gegevens. Hierdoor kan de website nog beter op bezoekers worden afgestemd. De verzamelde
  gegevens gebruikt bzconfregistration.azurewebsites.net niet voor een ander doel dan voor verbetering van de website.
  In onderstaande tabel ziet u welke cookies dit zijn.</p>
<table>
  <thead>
    <tr>
    <td>Naam Cookie</td>
    <td>Doel</td>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Cookie_pk_id</td>
      <td>Is de bezoeker nieuw of heeft de bezoeker de site al eerder bezocht?</td>
    </tr>
    <tr>
      <td>Cookie _pk_ses</td>
      <td>Welke pagina's heeft de bezoeker geraadpleegd?</td>
    </tr>
    <tr>
      <td>Cookie _pk_ref</td>
      <td>Vanaf welke site is de bezoeker gekomen?</td>
    </tr>
  </tbody>
</table>

<h2>BZ Conferencing app statistieken</h2>
<p>Bij gebruik van de BZ Conferencing app worden ook statistieken bijgehouden. Deze zijn geanonimiseerd, er worden geen persoonsgegevens bewaard Deze gegevens bestaan o.a. uit een installatie ID, versie van de app, toestelgegevens (zoals model en besturingssysteem) en handelingen (openen van schermen en laden van events).</p>

<p>Daarnaast worden eventuele crashes van de app bijgehouden, welke na het herstarten worden verzonden. Deze worden gebruikt om problemen op te kunnen lossen. Ook hierbij worden geen persoonsgegevens bewaard.</p>